<template>
  <div>
    <h3 class="mb-5">每季營運報告</h3>

    <!-- itemList -->
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q1</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-簡明損益表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-簡明損益表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.income_statement1_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-資產負債表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-資產負債表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.balance_sheet1_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-現金流量表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-現金流量表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.cash_flow1_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-法人說明會簡報 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-法人說明會簡報</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.seminar1_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 設定日期 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-3">Date</h4>
            <div class="h5 ink-02-medium--text mb-3">

            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
            <v-menu
              v-model="dateMenu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="financial.operation1_date"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="financial.operation1_date"
                @input="dateMenu1 = false"
              >
                <v-btn text color="primary" @click="financial.operation1_date = null">清除</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </template>
    </PageCollapse>
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q2</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-簡明損益表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-簡明損益表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.income_statement2_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-資產負債表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-資產負債表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.balance_sheet2_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-現金流量表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-現金流量表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.cash_flow2_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-法人說明會簡報 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-法人說明會簡報</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.seminar2_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 設定日期 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-3">Date</h4>
            <div class="h5 ink-02-medium--text mb-3">

            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
            <v-menu
              v-model="dateMenu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="financial.operation2_date"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="financial.operation2_date"
                @input="dateMenu2 = false"
              >
                <v-btn text color="primary" @click="financial.operation2_date = null">清除</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </template>
    </PageCollapse>
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q3</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-簡明損益表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-簡明損益表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.income_statement3_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-資產負債表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-資產負債表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.balance_sheet3_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-現金流量表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-現金流量表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.cash_flow3_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-法人說明會簡報 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-法人說明會簡報</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.seminar3_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 設定日期 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-3">Date</h4>
            <div class="h5 ink-02-medium--text mb-3">

            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
            <v-menu
              v-model="dateMenu3"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="financial.operation3_date"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="financial.operation3_date"
                @input="dateMenu3 = false"
              >
                <v-btn text color="primary" @click="financial.operation3_date = null">清除</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </template>
    </PageCollapse>
    <PageCollapse>
      <template v-slot:head>
        <h3 class="mr-auto">Q4</h3>
      </template>
      <template v-slot:body>
        <!-- 上傳檔案-簡明損益表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-簡明損益表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.income_statement4_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-資產負債表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-資產負債表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.balance_sheet4_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-現金流量表 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-現金流量表</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.cash_flow4_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 上傳檔案-法人說明會簡報 -->
        <div class="form-item d-flex py-5 mb-5">
          <div class="w-240px mr-5">
            <h4 class="mb-10px">上傳檔案-法人說明會簡報</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="financial.seminar4_report"
              dir="ir"></FileUploader>
          </div>
        </div>
        <!-- 設定日期 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4 class="mb-3">Date</h4>
            <div class="h5 ink-02-medium--text mb-3">

            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
            <v-menu
              v-model="dateMenu4"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="financial.operation4_date"
                  placeholder="請選擇日期"
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="financial.operation4_date"
                @input="dateMenu4 = false"
              >
                <v-btn text color="primary" @click="financial.operation4_date = null">清除</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  props: {
    financial: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PageCollapse,
    FileUploader,
  },
  data: () => ({
    dateMenu1: false,
    dateMenu2: false,
    dateMenu3: false,
    dateMenu4: false,
  }),
};
</script>

<style></style>
